module.exports = __webpack_public_path__ + "static/media/avatar-S_Q.d3a021b4.png";